const ACCOUNT_DATA_RESTORED_EVENT = 'bunko:account-data-restored';

type AccountDataRestoredListener = () => void;

function hasWindowEventTarget(): boolean {
  return typeof window !== 'undefined' && typeof window.dispatchEvent === 'function';
}

export function notifyAccountDataRestored(): void {
  if (!hasWindowEventTarget()) return;
  window.dispatchEvent(new Event(ACCOUNT_DATA_RESTORED_EVENT));
}

export function subscribeAccountDataRestored(
  listener: AccountDataRestoredListener,
): () => void {
  if (!hasWindowEventTarget()) return () => undefined;
  window.addEventListener(ACCOUNT_DATA_RESTORED_EVENT, listener);
  return () => window.removeEventListener(ACCOUNT_DATA_RESTORED_EVENT, listener);
}
